var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "image-segmentation-preview-modal",
        size: "xl",
        scrollable: "",
        "no-close-on-backdrop": "",
      },
      on: { show: _vm.onModalShow, hide: _vm.onModalHide },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "d-flex align-items-center w-100" }, [
                _c("h5", { staticClass: "modal-title mb-0" }, [
                  _vm._v("\n        " + _vm._s(_vm.modalTitle) + "\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "ml-auto d-flex align-items-center header-toggles",
                  },
                  [
                    _vm.currentStep === "preview"
                      ? [
                          _vm.removableBgLayerIds.length > 0
                            ? _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    checked: _vm.allRemoveBg,
                                    switch: "",
                                  },
                                  on: { change: _vm.toggleAllRemoveBg },
                                },
                                [
                                  _vm._v(
                                    "\n            Remove background\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.convertibleLayerIds.length > 0
                            ? _c(
                                "b-form-checkbox",
                                {
                                  attrs: {
                                    checked: _vm.allConvertToText,
                                    switch: "",
                                  },
                                  on: { change: _vm.toggleAllConvertToText },
                                },
                                [
                                  _vm._v(
                                    "\n            Convert to editable text\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-dropdown",
                            {
                              attrs: {
                                size: "sm",
                                variant: "link",
                                "toggle-class":
                                  "text-decoration-none text-muted px-2",
                                "no-caret": "",
                                right: "",
                                "menu-class": "segmentation-options-menu",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "button-content",
                                    fn: function () {
                                      return [
                                        _c("b-icon", {
                                          attrs: {
                                            icon: "three-dots-vertical",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("More options"),
                                        ]),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "b-dropdown-item",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.showLayerDetails =
                                        !_vm.showLayerDetails
                                    },
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    staticClass: "mr-1",
                                    class: { invisible: !_vm.showLayerDetails },
                                    attrs: { icon: "check" },
                                  }),
                                  _vm._v(
                                    "\n              Show layer details\n            "
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.hasProductGroups
                                ? _c(
                                    "b-dropdown-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.toggleGroupProducts.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("b-icon", {
                                        staticClass: "mr-1",
                                        class: {
                                          invisible: !_vm.groupProducts,
                                        },
                                        attrs: { icon: "check" },
                                      }),
                                      _vm._v(
                                        "\n              Group side-by-side products\n            "
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isImprovingAnyLayer
                      ? _c(
                          "button",
                          {
                            staticClass: "close",
                            attrs: { type: "button", "aria-label": "Close" },
                            on: { click: close },
                          },
                          [_vm._v("\n          ×\n        ")]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _vm.currentStep === "select"
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.hide(
                                "image-segmentation-preview-modal"
                              )
                            },
                          },
                        },
                        [_vm._v("\n        Cancel\n      ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: !_vm.selectedImage,
                          },
                          on: { click: _vm.startSegmentationFromSelection },
                        },
                        [_vm._v("\n        Segment Image\n      ")]
                      ),
                    ],
                    1
                  )
                : _vm.currentStep === "preview" && _vm.layers.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column flex-md-row justify-content-between w-100",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "outline-secondary",
                                disabled: _vm.isImprovingAnyLayer,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$bvModal.hide(
                                    "image-segmentation-preview-modal"
                                  )
                                },
                              },
                            },
                            [_vm._v("\n          Cancel\n        ")]
                          ),
                          _vm._v(" "),
                          _vm.canReanalyze
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    variant: "outline-warning",
                                    disabled:
                                      _vm.isReanalyzing ||
                                      _vm.isImprovingAnyLayer,
                                  },
                                  on: { click: _vm.reanalyze },
                                },
                                [
                                  _vm.isReanalyzing
                                    ? _c(
                                        "span",
                                        [
                                          _c("b-spinner", {
                                            staticClass: "mr-1",
                                            attrs: { small: "" },
                                          }),
                                          _vm._v(
                                            "\n            Re-analyzing...\n          "
                                          ),
                                        ],
                                        1
                                      )
                                    : _c("span", [
                                        _c("i", {
                                          staticClass: "fas fa-redo mr-1",
                                        }),
                                        _vm._v(
                                          "\n            Re-analyze\n          "
                                        ),
                                      ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex flex-wrap mt-2 mt-md-0" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { variant: "outline-primary" },
                              on: { click: _vm.selectAllLayers },
                            },
                            [_vm._v("\n          Select All\n        ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                variant: "primary",
                                disabled:
                                  _vm.selectedLayerIds.length === 0 ||
                                  _vm.isImprovingAnyLayer,
                              },
                              on: { click: _vm.confirmSelection },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.confirmButtonText) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _c(
                    "div",
                    { staticClass: "d-flex justify-content-end w-100" },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "outline-secondary" },
                          on: {
                            click: function ($event) {
                              return _vm.$bvModal.hide(
                                "image-segmentation-preview-modal"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.hasError ? "Close" : "Cancel") +
                              "\n      "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _vm.currentStep === "select"
        ? _c(
            "div",
            { staticClass: "py-3" },
            [
              _c("p", { staticClass: "mb-3" }, [
                _vm._v(
                  "\n      Select an image from the file browser to segment into layers:\n    "
                ),
              ]),
              _vm._v(" "),
              _c("FolderContentView", {
                attrs: { "is-only-folder": true, "page-size": 8 },
                on: { onSelectedItems: _vm.handleSelectedItems },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group mt-3" },
                [
                  _c("label", { attrs: { for: "layout-name-select" } }, [
                    _vm._v("Layout Name"),
                  ]),
                  _vm._v(" "),
                  _c("b-form-input", {
                    attrs: {
                      id: "layout-name-select",
                      placeholder: "Enter a name for the new layout",
                    },
                    model: {
                      value: _vm.layoutName,
                      callback: function ($$v) {
                        _vm.layoutName = $$v
                      },
                      expression: "layoutName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm.isProcessing
        ? _c(
            "div",
            { staticClass: "text-center py-5" },
            [
              _c("b-spinner", {
                staticClass: "mb-3",
                staticStyle: { width: "3rem", height: "3rem" },
                attrs: { variant: "primary" },
              }),
              _vm._v(" "),
              _c("h5", [_vm._v("Analyzing image with AI...")]),
              _vm._v(" "),
              _c("p", { staticClass: "text-muted" }, [
                _vm._v(
                  "\n      This may take a minute. We're detecting layers, products, and background elements.\n    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-progress",
                {
                  staticClass: "mt-3",
                  attrs: { value: _vm.progressValue, max: 100, animated: "" },
                },
                [
                  _c(
                    "b-progress-bar",
                    { attrs: { value: _vm.progressValue } },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.progressValue) + "%\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm.hasError
        ? _c("div", { staticClass: "text-center py-5" }, [
            _c("div", { staticClass: "text-danger mb-3" }, [
              _c("i", {
                staticClass: "fas fa-exclamation-circle",
                staticStyle: { "font-size": "3rem" },
              }),
            ]),
            _vm._v(" "),
            _c("h5", [_vm._v("Segmentation Failed")]),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "\n      Unable to process the image. Please try again or select a different image.\n    "
              ),
            ]),
          ])
        : _vm.currentStep === "preview" && _vm.layers.length > 0
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "mb-3 p-3 bg-light rounded border" },
                [
                  _c(
                    "label",
                    { staticClass: "font-weight-bold mb-2 d-block" },
                    [_vm._v("Extraction Mode")]
                  ),
                  _vm._v(" "),
                  _c("b-form-radio-group", {
                    attrs: {
                      options: [
                        { text: "Full Segmentation", value: "full" },
                        { text: "Product Only", value: "product_only" },
                      ],
                      buttons: "",
                      "button-variant": "outline-primary",
                      size: "sm",
                    },
                    model: {
                      value: _vm.extractionMode,
                      callback: function ($$v) {
                        _vm.extractionMode = $$v
                      },
                      expression: "extractionMode",
                    },
                  }),
                  _vm._v(" "),
                  _vm.isProductOnlyMode
                    ? _c("small", { staticClass: "d-block text-muted mt-2" }, [
                        _vm._v(
                          "\n        Only product layers will be extracted. Background will use the original image with product areas removed.\n      "
                        ),
                      ])
                    : _c("small", { staticClass: "d-block text-muted mt-2" }, [
                        _vm._v(
                          "\n        All detected layers (products, text, background) will be extracted separately.\n      "
                        ),
                      ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", { staticClass: "mb-3" }, [
                _vm._v("\n      We detected "),
                _c("strong", [_vm._v(_vm._s(_vm.visibleLayers.length))]),
                _vm._v(
                  " layers in your image.\n      Select the layers you want to include in your template:\n    "
                ),
              ]),
              _vm._v(" "),
              _vm.isStaleAnalysis
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { show: "", variant: "warning" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-md-row align-items-md-center justify-content-between",
                        },
                        [
                          _c("div", [
                            _c("strong", [
                              _vm._v("These layers are out of date"),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            They were produced by an earlier version of the analysis. Re-analyzing picks up the\n            latest improvements.\n          "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3 mt-md-0 ml-md-3 flex-shrink-0",
                              attrs: {
                                variant: "warning",
                                disabled:
                                  _vm.isReanalyzing || _vm.isImprovingAnyLayer,
                              },
                              on: { click: _vm.reanalyze },
                            },
                            [
                              _vm.isReanalyzing
                                ? _c("b-spinner", {
                                    staticClass: "mr-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                              _vm._v("\n          Re-analyze\n        "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showImprovementAlert
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mb-3",
                      attrs: { show: "", variant: "info" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-md-row align-items-md-center justify-content-between",
                        },
                        [
                          _c("div", [
                            _c("strong", [_vm._v("AI improvements available")]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "\n            Product image crops and background infill can be improved using AI.\n          "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3 mt-md-0 ml-md-3 flex-shrink-0",
                              attrs: {
                                variant: "primary",
                                disabled: _vm.isImprovingAnyLayer,
                              },
                              on: { click: _vm.improveAllLayers },
                            },
                            [
                              _vm.isImprovingAll
                                ? _c("b-spinner", {
                                    staticClass: "mr-1",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.isImprovingAll
                                      ? "Improving..."
                                      : "Improve all layers"
                                  ) +
                                  "\n        "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("div", { staticClass: "col-md-4 mb-3" }, [
                    _c("div", { staticClass: "card h-100" }, [
                      _c("div", { staticClass: "card-header" }, [
                        _c("strong", [_vm._v("Original Image")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body text-center" }, [
                        _c("img", {
                          staticClass: "img-fluid layer-preview",
                          attrs: { src: _vm.originalImageUrl, alt: "Original" },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.inpaintedBackgroundUrl &&
                  !_vm.hasBackgroundLayer &&
                  !_vm.isProductOnlyMode
                    ? _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c("div", { staticClass: "card h-100" }, [
                          _c("div", { staticClass: "card-header" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between align-items-center",
                              },
                              [
                                _c("strong", [
                                  _vm._v("Background (Inpainted)"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "badge badge-info badge-pill",
                                  },
                                  [_vm._v("Included in Background")]
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-body text-center" }, [
                            _c("img", {
                              staticClass: "img-fluid layer-preview",
                              attrs: {
                                src: _vm.inpaintedBackgroundUrl,
                                alt: "Inpainted Background",
                              },
                            }),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.visibleLayers, function (layer) {
                    return _c(
                      "div",
                      { key: layer.id, staticClass: "col-md-4 mb-3" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "card h-100 layer-card",
                            class: {
                              "border-primary": _vm.isLayerSelected(layer.id),
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-header d-flex justify-content-between align-items-center",
                              },
                              [
                                _c("div", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(_vm.formatLayerType(layer.type))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(_vm._s(layer.description)),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("b-form-checkbox", {
                                  attrs: {
                                    checked: _vm.isLayerSelected(layer.id),
                                    switch: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.toggleLayer(layer.id)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-body text-center layer-preview-container",
                              },
                              [
                                _c("img", {
                                  staticClass: "img-fluid layer-preview",
                                  class: {
                                    "opacity-50": !_vm.isLayerSelected(
                                      layer.id
                                    ),
                                  },
                                  attrs: {
                                    src: _vm.getShareUrl(
                                      layer.image_path || layer.preview_url
                                    ),
                                    alt: layer.description,
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.showLayerDetails,
                                        expression: "showLayerDetails",
                                      },
                                    ],
                                    staticClass: "layer-info mt-2",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "badge badge-secondary" },
                                      [
                                        _vm._v(
                                          "\n                z-index: " +
                                            _vm._s(layer.z_index) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    layer.confidence
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "badge",
                                            class: _vm.getConfidenceBadgeClass(
                                              layer.confidence
                                            ),
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(layer.confidence) +
                                                "% confidence\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                layer.type === "product" &&
                                _vm.isLayerSelected(layer.id)
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              checked: _vm.isRemoveBg(layer.id),
                                              size: "sm",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleRemoveBg(
                                                  layer.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Remove background\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-1",
                                            attrs: {
                                              checked: _vm.hasOvalShadow(
                                                layer.id
                                              ),
                                              size: "sm",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleOvalShadow(
                                                  layer.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Add oval shadow\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                layer.type === "text_image" &&
                                _vm.isLayerSelected(layer.id) &&
                                !_vm.isProductOnlyMode
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              checked: _vm.isConvertToText(
                                                layer.id
                                              ),
                                              size: "sm",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleConvertToText(
                                                  layer.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Convert to editable text\n              "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-1",
                                            attrs: {
                                              checked: _vm.isRemoveBg(layer.id),
                                              size: "sm",
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.toggleRemoveBg(
                                                  layer.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                Remove background\n              "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            layer.type === "background" ||
                            layer.type === "product"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "card-footer d-flex align-items-center layer-retry-row",
                                  },
                                  [
                                    _c("b-form-input", {
                                      staticClass: "mr-2 layer-guidance-input",
                                      attrs: {
                                        value: _vm.guidanceFor(layer.id),
                                        size: "sm",
                                        placeholder:
                                          _vm.guidancePlaceholder(layer),
                                        maxlength: _vm.guidanceMaxLength,
                                        disabled: _vm.isImprovingLayer(
                                          layer.id
                                        ),
                                        title: _vm.guidanceFor(layer.id),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                        },
                                        input: function ($event) {
                                          return _vm.setGuidance(
                                            layer.id,
                                            $event
                                          )
                                        },
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.improveLayer(layer)
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "text-nowrap",
                                        attrs: {
                                          variant: "outline-primary",
                                          size: "sm",
                                          disabled: _vm.isImprovingLayer(
                                            layer.id
                                          ),
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.improveLayer(layer)
                                          },
                                        },
                                      },
                                      [
                                        _vm.isImprovingLayer(layer.id)
                                          ? _c("b-spinner", {
                                              staticClass: "mr-1",
                                              attrs: { small: "" },
                                            })
                                          : _c("b-icon", {
                                              staticClass: "mr-1",
                                              attrs: { icon: "arrow-repeat" },
                                            }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.getImproveButtonText(layer)
                                            ) +
                                            "\n            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _c("div", { staticClass: "text-center py-5" }, [
            _c("p", { staticClass: "text-muted" }, [
              _vm._v(
                "\n      No layers detected yet. Start by selecting an image to segment.\n    "
              ),
            ]),
          ]),
      _vm._v(" "),
      _c("b-overlay", {
        attrs: { show: _vm.isCreatingLayout, "no-wrap": "" },
        scopedSlots: _vm._u([
          {
            key: "overlay",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "text-center d-flex flex-column align-items-center justify-content-center",
                  },
                  [
                    _c("b-spinner", {
                      staticClass: "mb-2",
                      attrs: { variant: "primary" },
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v(
                        "\n          Creating layout from layers...\n        "
                      ),
                    ]),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }